import { Link } from 'react-router';

export function Mark() {
  return (
    <svg className="mark" viewBox="0 0 34 34" aria-hidden="true">
      <circle className="mark-disc" cx="17" cy="17" r="16" />
      <circle className="mark-wheel" cx="10.2" cy="21.6" r="5.35" />
      <circle className="mark-wheel-inner" cx="10.2" cy="21.6" r="3.72" />
      <circle className="mark-wheel" cx="24" cy="21.6" r="5.35" />
      <circle className="mark-wheel-inner" cx="24" cy="21.6" r="3.72" />
      <path
        className="mark-bike"
        d="m10.2 21.6 4.4-8 3.2 8 3.8-8 2.4 8M14.6 13.6h7l-3.8 8h-7.6M14.6 13.6l-1.2-3.1M21.6 13.6l-.9-3h3.4c1.5 0 1.8 1.6.5 2.3M4.9 22.6h2.1"
      />
      <path className="mark-seat" d="M11.7 10.4h4.3" />
      <rect className="mark-bag" x="6.3" y="14.1" width="5" height="6.5" rx="1.2" />
      <path className="mark-bag-line" d="M6.8 16.1h4" />
      <circle className="mark-live-ring" cx="24" cy="21.6" r="1.72" />
      <circle className="mark-live" cx="24" cy="21.6" r="1.1" />
      <circle className="mark-live-core" cx="24" cy="21.6" r="0.38" />
    </svg>
  );
}

export function Brand({ linked = true }: { linked?: boolean }) {
  const content = (
    <span className="brand-lockup">
      <Mark />
      <span>Bikepacking Live</span>
    </span>
  );
  return linked ? (
    <Link to="/" aria-label="Bikepacking Live home">
      {content}
    </Link>
  ) : (
    content
  );
}
